import apiClient from "./client";

const appendQrCodeIdToFormData = (formData, qrCodeId) => {
  if (qrCodeId !== "" && qrCodeId !== null && typeof qrCodeId !== "undefined") {
    formData.append("qr_code_id", String(qrCodeId));
  }
};

const buildPetPayload = (payload, qrCodeId) => {
  if (payload instanceof FormData) {
    appendQrCodeIdToFormData(payload, qrCodeId);
    return {
      data: payload,
      config: {
        headers: { "Content-Type": "multipart/form-data" },
      },
      isFormData: true,
    };
  }

  return {
    data: {
      ...payload,
      qr_code_id: qrCodeId,
    },
    isFormData: false,
  };
};

export const fetchPets = async () => {
  const response = await apiClient.get("/api/pets");
  return response.data.data ?? [];
};

export const createPet = async (payload, qrCodeId) => {
  const request = buildPetPayload(payload, qrCodeId);
  const response = await apiClient.post("/api/pets", request.data, request.config);

  return response.data.data ?? response.data;
};

export const updatePet = async (petId, payload, qrCodeId) => {
  const request = buildPetPayload(payload, qrCodeId);
  const response = request.isFormData
    ? await apiClient.post(`/api/pets/${petId}`, request.data, request.config)
    : await apiClient.patch(`/api/pets/${petId}`, request.data, request.config);

  return response.data.data ?? response.data;
};

export const deletePetById = async (petId) => {
  await apiClient.delete(`/api/pets/${petId}`);
};
